import { BehaviorSubject, distinctUntilChanged, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IInventoryCategory } from '@inventory/models/inventory';
import { SwitchControlComponent } from '@shared/components/forms/switch-control/switch-control.component';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';
import { NullDefaultPipe } from '@shared/pipes/null-default.pipe';

@Component({
	selector: 'app-mobile-inventory-categories-table',
	imports: [CommonModule, LoadingStateComponent, NullDefaultPipe, SwitchControlComponent],
	templateUrl: './mobile-inventory-categories-table.component.html',
	styleUrl: './mobile-inventory-categories-table.component.scss',
	host: {
		class: 'h-100',
	},
})
export class MobileInventoryCategoriesTableComponent implements OnInit, OnDestroy {
	@Input() isLoading: boolean;
	@Input() categoryItems: Array<IInventoryCategory>;
	@Input() showArchived$: BehaviorSubject<boolean>;
	@Output() inventoryCategoryEdit = new EventEmitter<IInventoryCategory>();
	@Output() inventoryCategoryArchive = new EventEmitter<IInventoryCategory>();
	@Output() inventoryCategoryUnarchive = new EventEmitter<IInventoryCategory>();
	@Output() addNewEvent = new EventEmitter<void>();

	destroyed$ = new EventEmitter<void>();

	form: FormGroup<{ showArchived: FormControl }>;

	get showArchived(): FormControl<boolean> {
		return this.form.controls.showArchived;
	}

	ngOnInit(): void {
		this.form = new FormGroup({
			showArchived: new FormControl<boolean>(false),
		});

		this.showArchived.valueChanges.pipe(takeUntil(this.destroyed$), distinctUntilChanged()).subscribe((value) => {
			this.showArchived$.next(value);
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}

	onInventoryCategoryEdit(category: IInventoryCategory) {
		this.inventoryCategoryEdit.emit(category);
	}

	onInventoryCategoryArchive(category: IInventoryCategory) {
		this.inventoryCategoryArchive.emit(category);
	}

	onInventoryCategoryUnarchive(category: IInventoryCategory) {
		this.inventoryCategoryUnarchive.emit(category);
	}

	onAddNewClick() {
		this.addNewEvent.emit();
	}
}
